import {ModalService} from './modal-service';

export class SimpleModalService extends ModalService<boolean> {

  openModal(): void {
    super.openModal(true);
  }

}
